import React, {useCallback, useState} from 'react';
import {Box, Button, Collapse, Stack} from "@mui/material";
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import {useTranslation} from "react-i18next";
import {checkLanguage, Language} from "language";
import {TitleLink} from 'components/RenderSuggestion';
import {useLocation, useNavigate, useParams} from "react-router-dom"; // NEW

export interface NavigateMenuProps {
  py?: number | undefined;
  mt?: number;
}

function NavigateMenu({py, mt}: NavigateMenuProps) {
  const {t, i18n} = useTranslation('navigateMenu');
  const languages: Language[] = [Language.En, Language.Ua];

  const { lang } = useParams();                     // NEW
  const navigate = useNavigate();                   // NEW
  const location = useLocation();                   // NEW

  const [lng, setLng] = useState<Language>(checkLanguage(i18n.language) as Language);
  const [open, setOpen] = useState<boolean>(false);

  // const changeLanguage = useCallback(() => {
  //   const currentIndex = languages.indexOf(lng);
  //   const next = languages[(currentIndex + 1) % languages.length];      // 'en' | 'ua'
  //   setLng(next);

  //   // i18next uses 'uk' (not 'ua')
  //   const nextI18n = next === Language.Ua ? 'uk' : 'en';
  //   i18n.changeLanguage(nextI18n);
  //   localStorage.setItem("lng", nextI18n);

  //   // replace the 1st URL segment and keep query/hash
  //   const parts = location.pathname.split('/');
  //   parts[1] = next; // en/ua
  //   navigate(parts.join('/') + location.search + location.hash, { replace: true });
  // }, [lng, i18n, navigate, location.pathname, location.search, location.hash]);

  const changeLanguage = useCallback(async () => {
    const next = lng === Language.En ? Language.Ua : Language.En; // 'en'|'ua'
    setLng(next);

    const nextI18n = next === Language.Ua ? 'uk' : 'en';          // <-- i18n codes
    await i18n.changeLanguage(nextI18n);                           // <-- await ensures rerender
    localStorage.setItem("lng", nextI18n);

    // keep same page, flip /en <-> /ua
    const parts = location.pathname.split('/');
    parts[1] = next;                                               // 'en'|'ua'
    navigate(parts.join('/') + location.search + location.hash, { replace: true });

    console.log('i18n.language', i18n.language); // should be 'en' or 'uk' after click
  }, [lng, i18n, navigate, location.pathname, location.search, location.hash]);

  function scrollTo(id: string) {
    return () => {
      const target = id.slice(1);
      document.getElementById(target)?.scrollIntoView({behavior: 'smooth'});
    }
  }

  const textSize = 'clamp(18px, calc(18px + 16 * (100vw / 1280)), 27px)';

  const toggleOpen = useCallback(() => {
    setOpen(prev => !prev);
  }, []);

  function RenderMenu() {
    return (
      <Stack direction={{xs: 'column', md: 'row'}} justifyContent='space-evenly' flexWrap='wrap'>
        <Button sx={{textTransform: 'none', fontSize: textSize}} href={TitleLink.OrderServices}>
          {t('order')}
        </Button>
        <Button sx={{textTransform: 'none', fontSize: textSize}} href={TitleLink.ProvideServices}>
          {t('provide')}
        </Button>
        <Button sx={{textTransform: 'none', fontSize: textSize}} href={TitleLink.DownloadMobile}>
          {t('downloadApplication')}
        </Button>
        <Button sx={{textTransform: 'none', fontSize: textSize}} href={TitleLink.AboutLogistics}>
          {t('aboutLogistic')}
        </Button>
        <Button sx={{textTransform: 'uppercase', fontSize: textSize}} onClick={changeLanguage}>
          {lng}
        </Button>
      </Stack>
    )
  }

  return (
    <Box py={py} mt={mt}>
      <Box display={{xs: 'block', md: 'none'}}>
        <Stack alignItems='center' justifyContent='center' direction='row'>
          <Button endIcon={open ? <ExpandLess/> : <ExpandMore/>}
                  sx={{textTransform: 'none', fontSize: textSize}}
                  onClick={toggleOpen}>{t('menu')}</Button>
        </Stack>
        <Collapse in={open}>
          {RenderMenu()}
        </Collapse>
      </Box>

      <Box display={{xs: 'none', md: 'block'}}>
        {RenderMenu()}
      </Box>
    </Box>
  );
}

export default NavigateMenu;
